export const iconFontAwesomeBuildingsWarehouse = (
	<i className="fa-solid fa-warehouse"></i>
);
